import { END_POINTS } from "../constants/urls";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  statusCode: number;
  data?: User;
  message: string;
}

interface CommonResponse {
  statusCode: number;
  message?: string;
  data?: any;
}

export const LogsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getActivityLogList: builder.query<
      CommonResponse & { data: any },
      {
        page: number;
        limit: number;
        search?: string;
        module?: any;
      }
    >({
      query: ({ page, search, limit, module }) => {
        const params = new URLSearchParams({
          page: page.toString(),
        });
        if (search) {
          params.append("search", search);
        }
        if (module) {
          params.append("module", module.toString());
        }
        return {
          url: `${END_POINTS.logs}?${params}&limit=${limit}`,
          method: "GET",
        };
      },
    }),
    updateActivityLog: builder.mutation<
      CommonResponseType & { data: any },
      { body: any; id: string }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.logs}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    getLoginHistory: builder.query<
      CommonResponse & { data: any },
      {
        userId: string;
        page: number;
        limit: number;
      }
    >({
      query: ({ userId, page, limit }) => {
        const params = new URLSearchParams({
          page: page.toString(),
          userId: userId,
        });
        return {
          url: `${END_POINTS.logs}?${params}&limit=${limit}`,
          method: "GET",
        };
      },
    }),
  }),
});
export const { useLazyGetActivityLogListQuery, useLazyGetLoginHistoryQuery } =
  LogsApi;
